export const environment = {
    production: false,
    envName: 'staging',
    apiUrl: 'https://studio-staging.floori.io/new-floori',
    cdnUrl: 'https://d2xsg7d4c6iu77.cloudfront.net',
    flooriWebsite: 'https://floori.io',
    bookDemoUrl: 'https://floori.io/LANG/contact/',
    supportEmail: 'support@floori.io',
    version: '2.0.40',
    sentryKey: '',
    gtmUrl: '',
    gtmKey: '',
    interactionKey: '',
    showDebugData: false,
    showDevTools: true,
    bonaAdditionsIds:
        '5443e2ccafafeda4918835cc1563cdbd1f9fc0320df53d57c6e45dbd370f5a6cd34a5867431ce43026a7b2120717a3b7a212',
    bonaCustomHeaderIds:
        '5e6be57c4af9627eba4325679b683f856c77e16cb668391ca1df92d10ffce42d0561dad2da46378a16171ef53c3026dfa752,' +
        '91a8402e08fa604e9cf310132cfaf4b17bb01918a3318a19016ed8ccefaf22cfd7a7df10b1c7ffe8dab51e75623ef86198eb,' +
        '5443e2ccafafeda4918835cc1563cdbd1f9fc0320df53d57c6e45dbd370f5a6cd34a5867431ce43026a7b2120717a3b7a212,' +
        '8fcbddafc11f3d6c13a81981fca2240c0c2a42632488436cb77b19f1c575a223c5a7f03d941e541d560ec2861b63c5bdf425,' +
        '7c4dae2c7da8dc18d2354c2b0c2153b4c61808f12583f75749e9220b79f6919a2d0ec62a53e9effa3751ee8feaf3d6e851ef',
    darkThemeSupportIds:
        '911c9991e3d43114ad19996ea01aea75324a967ffc137f1436f28e82fffc5274b0ec5810981d2cb2198c47001adc0483c807,' +
        '885d0bf15d81ddb78ec31780917d3b788a89dfa741bfdbf0b5ac68777fcdbee37752477ff0b0865f82c9878b619943a91845,' +
        'dcc0aac051f994f27b8649be3d120bfb77d3f55409bc063c0b43f5fefc617bbf21a266d00f10aecdaf28543a1e813e9597c4',
    clarityScriptSupportIds: '',
    recaptchaSiteKey: '',
};
